import React, { useCallback, useState } from "react";
import { Typography } from "antd";

interface IProps {
  text: string;
}

const TextLoadMore = (props: IProps) => {
  const { text = "" } = props;
  const [showMore, setShowMore] = useState<boolean>(false);

  const handleExpand = useCallback(() => {
    setShowMore(true);
  }, []);

  return (
    <Typography.Paragraph
      ellipsis={{
        rows: 3,
        expandable: true,
        symbol: "Show More",
        // onExpand: handleExpand,
      }}
    >
      {text}
    </Typography.Paragraph>
  );
};

export default React.memo(TextLoadMore);
